var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"detail-model",style:(`
  background-color: ${_vm.dataSource.background};
  height: ${_vm.$px2rem(_vm.dataSource.height)}
`)},_vm._l((_vm.dataSource.images),function(item,index){return _c('div',{key:index,style:(`
        width: ${_vm.$px2rem(1200)};
        height: ${_vm.$px2rem(item.height)};
        z-index: ${item.zIndex};
      `)},[(!item.isbg && typeof item.url === 'string')?_c('LazyImg',{attrs:{"className":"img","styles":`
        width: ${_vm.$px2rem(item.width)};
        height: ${_vm.$px2rem(item.height)};
        z-index: ${item.zIndex};
        top: ${_vm.$px2rem(item.top)};
      `,"src":item.url}}):_vm._e(),_vm._v(" "),(!item.isbg && typeof item.url !== 'string')?_c('div',{staticClass:"swiper-box",style:(`
          width: ${_vm.$px2rem(item.width)};
          height: ${_vm.$px2rem(item.height)};
          top: ${_vm.$px2rem(item.top)};
          z-index: ${item.zIndex};
        `)},[_c('swiper',{ref:"swiper",refInFor:true,style:(`
          width: ${_vm.$px2rem(item.width)};
        height: ${_vm.$px2rem(item.height)};
        `),attrs:{"options":_vm.swiperOptions}},_vm._l((item.url),function(it,i){return _c('swiper-slide',{key:i,style:(`
              width: ${_vm.$px2rem(item.width)};
              height: ${_vm.$px2rem(item.height)};
            `)},[_c('LazyImg',{attrs:{"styles":`
              width: ${_vm.$px2rem(item.width)};
              height: ${_vm.$px2rem(item.height)};
            `,"src":it}})],1)}),1),_vm._v(" "),_c('i',{ref:"prev",refInFor:true,class:`
            iconfont 
            ${_vm.upBtnHover ? 'iconbanner_switch_hover_ic' : 'iconbanner_switch_ic'} 
            swiper-progress-up
          `,on:{"click":function($event){return _vm.onSwiper('slidePrev')},"mouseover":function($event){_vm.upBtnHover = true},"mouseout":function($event){_vm.upBtnHover = false}}}),_vm._v(" "),_c('i',{ref:"next",refInFor:true,class:`
            iconfont 
            ${_vm.nextBtnHover ? 'iconbanner_switch_hover_ic' : 'iconbanner_switch_ic'} 
            swiper-progress-next
          `,on:{"click":function($event){return _vm.onSwiper('slideNext')},"mouseover":function($event){_vm.nextBtnHover = true},"mouseout":function($event){_vm.nextBtnHover = false}}})],1):_vm._e(),_vm._v(" "),(item.isbg)?_c('LazyImg',{attrs:{"className":"img img-bg","styles":`
        width: ${_vm.$px2rem(item.width)};
        height: ${_vm.$px2rem(item.height)};
        z-index: ${item.zIndex};
        top: ${_vm.$px2rem(item.top)};
        transform: translateX(${_vm.$px2rem(item.moveX)});
      `,"src":item.url,"noBackground":true}}):_vm._e(),_vm._v(" "),(item.special)?_c('div',{staticClass:"special-box"},[_vm._l((item.showImg),function(it,index){return _c('div',{key:it.id,class:`show-box show-box-${index + 1} watch`},[_c('LazyImg',{attrs:{"src":_vm.ossProcessImg(it.url, 284)}}),_vm._v(" "),_c('div',{staticClass:"operation"},[_vm._v(_vm._s(it.desc))])],1)}),_vm._v(" "),_vm._l((item.coverQrcode),function(im,index){return _c('div',{key:im.id,class:`show-box show-box-${index + 1} qrcode`},[_c('LazyImg',{attrs:{"src":_vm.ossProcessImg(item.bg, 284),"className":"common-bg"}}),_vm._v(" "),_c('div',{staticClass:"qrcode-box"},[_c('LazyImg',{attrs:{"src":_vm.ossProcessImg(im.url, 288)}})],1),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(im.desc))])],1)})],2):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }